import { BodyRegular, FlexCol, NavLinkNoWrap } from 'components/Elements';
import React from 'react';
import styled from 'styled-components';
import { sizes, breakpoints } from 'theme';
import strings from '../../strings/strings.json';

export default function LogoAndContactLink(): JSX.Element {
    const emailSubject = encodeURIComponent('Neve Learning Support');
    const emailBody = encodeURIComponent(`Describe your issue or feedback here: \n`);

    return (
        <LogoAndContactLinkContainer>
            <BodyRegular $inverted>
                {strings.contactPanel.bodyText}
                <NavLinkNoWrap
                    to={`mailto:support@nevelearning.co.uk?subject=${emailSubject}&body=${emailBody}`}
                    aria-label={strings.contactPanel.supportLinkAria}
                    target="_blank"
                    $inverted
                >
                    {strings.contactPanel.neveSupportEmail}
                </NavLinkNoWrap>
            </BodyRegular>
        </LogoAndContactLinkContainer>
    );
}

const LogoAndContactLinkContainer = styled(FlexCol)`
    gap: ${sizes.spacingMd};
    align-items: center;
    width: 100%;

    @media (max-width: ${breakpoints.md}) {
        align-items: unset;
    }
`;
